<template>
    <div class="text row smallwidth">
        <div class="col">
            <h1 v-html="b.header" class="zzgray"></h1>
            <div class="text" v-html="b.text"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "SimpleText",
        props: {b: Object}
    }
</script>
<style scoped lang="scss">
    .smallwidth {
        h1 {
            border-bottom: none;
        }
        .text {
            //styleName: <p> - copy BIG;
            font-family: $sans;
        }
    }
</style>